module.exports = __webpack_public_path__ + "static/img/pic_3.30b83ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic_3.png
// module id = i5Fi
// module chunks = 1